import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { startLoading, stopLoading } from 'src/features/loading/loadingStore';
import { fetchDriverConfigApi, fetchDriverInfoApi } from 'src/api/driverInfo';
import { handleErrorSaga } from 'src/utils/handleErrorSaga';
import {
  fetchDriverConfig,
  fetchDriverInfo,
  fetchDutyStatusLogs,
  changeDutyStatus,
  setDriverInfo,
  setDutyStatus,
  setDutyStatusSuccess,
  setDriverConfig,
} from 'src/features/profile/store/profileStore';
import { DriverConfigType, DriverInfo } from 'src/features/profile/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { DutyStatus, FetchDutyStatusPayload, ChangeDutyStatusPayload } from 'src/common/types';
import { changeDutyStatusApi, fetchDutyStatusApi } from 'src/api/currentDutyStatus';
import { handleSuccessSaga } from 'src/utils/handleSuccessSaga';
import { AxiosError } from 'axios';

export function* fetchDriverInfoSaga(): SagaIterator {
  try {
    yield put(startLoading());
    const response: DriverInfo = yield call(fetchDriverInfoApi);
    yield put(setDriverInfo(response));
  } catch (error) {
    yield call(handleErrorSaga, error as AxiosError);
  } finally {
    yield put(stopLoading());
  }
}

export function* fetchDutyStatusSaga(action: PayloadAction<FetchDutyStatusPayload>): SagaIterator {
  try {
    yield put(startLoading());
    const response: DutyStatus = yield call(fetchDutyStatusApi, action.payload);

    yield put(setDutyStatus(response));
  } catch (error) {
    yield call(handleErrorSaga, error);
  } finally {
    yield put(stopLoading());
  }
}

export function* changeDutyStatusSaga(
  action: PayloadAction<ChangeDutyStatusPayload>,
): SagaIterator {
  try {
    yield put(startLoading());
    yield call(changeDutyStatusApi, action.payload);
    yield call(handleSuccessSaga, 'Current duty status successfully changed.');
    yield put(setDutyStatusSuccess(true));
    yield put(fetchDutyStatusLogs({ userId: action.payload.employeeId }));
  } catch (error) {
    yield call(handleErrorSaga, error);
  } finally {
    yield put(stopLoading());
  }
}

export function* fetchDriverConfigSaga(action: PayloadAction<number>): SagaIterator {
  try {
    yield put(startLoading());
    const response: DriverConfigType = yield call(fetchDriverConfigApi, action.payload);
    yield put(setDriverConfig(response));
  } catch (error) {
    yield call(handleErrorSaga, error);
  } finally {
    yield put(stopLoading());
  }
}

export function* watchProfileSagas(): SagaIterator {
  yield takeLatest(fetchDriverInfo, fetchDriverInfoSaga);
  yield takeLatest(fetchDutyStatusLogs, fetchDutyStatusSaga);
  yield takeLatest(changeDutyStatus, changeDutyStatusSaga);
  yield takeLatest(fetchDriverConfig, fetchDriverConfigSaga);
}
